import { connect } from 'react-redux';
import compose from 'redux/lib/compose';

import PublicNavigationLinks from './PublicNavigationLinks';

const mapStateToProps = state => ({
  publicHost: state.config.environmentConfig.web.public.host,
  accountHost: state.config.environmentConfig.web.account.host,
  showMenu: state.view.components.header?.showMenu,
});

const connected = connect(mapStateToProps);

export default compose(connected)(PublicNavigationLinks);
